import {useSelector} from 'react-redux';
import SimpleLoader from '@frontend/ui-kit/Components/Loader';
import {getLoaderStatus} from '../../../selectors/shared';
import './index.scss';

const Loader = () => {
    const isLoader = useSelector(getLoaderStatus);

    return <SimpleLoader className='loader' isLoader={isLoader}/>;
};

export {Loader as TestableLoader};
export default Loader;
